import React from 'react';

import t from 'lib/i18n';

export const FareClassTypes = {
  FIRST_CLASS: 'first-class',
  STANDARD: 'standard'
}

const FareClassLabel = ({ type }) => {
  const translateKey = `favourites.ticket.fareClass.${type === FareClassTypes.FIRST_CLASS ? 'firstClass' : 'standard'}`;

  return (
    <div
      className="otrl-jp__fare-class-label"
      aria-label={t(`${translateKey}.aria`)}
    >
      {t(translateKey)}
    </div>
  )
};

export default FareClassLabel;